import { render } from "./FormComponentConfig.html?vue&type=template&id=a4d0ad0e&scoped=true&ts=true"
import script from "./FormComponentConfig.ts?vue&type=script&lang=ts"
export * from "./FormComponentConfig.ts?vue&type=script&lang=ts"

import "./FormComponentConfig.scss?vue&type=style&index=0&id=a4d0ad0e&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4d0ad0e"]])

export default __exports__